import { findObjectsWithValidId, setRitems } from './utils'

export type SetItems = typeof setItems

export const setItems = (data: any, cleanTbAtRefs = false) => {
	if (data) {
		const rawItems = findObjectsWithValidId(data)
		return setRitems(rawItems, cleanTbAtRefs)
	}
	return
}
